import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { disableDevMode, enableDevMode } from "../../../../app/systemSlice";
import {
	moveSheetTo,
	selectCurrentTabIndex,
} from "../../../editor/editorSlice";
import { selectFetchLogicsStatus } from "../../../logics/logicsSlice";
import { closeMenu } from "../../menuManagerSlice";
import { MenuContent, menuItem } from "../Menu";
import { createWindow } from "../../../windowManager/windowManagerSlice";

export type ViewMenuType = "view";

export function ViewMenu() {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const currentTabIndex = useAppSelector(selectCurrentTabIndex);
	const logicsStatus = useAppSelector(selectFetchLogicsStatus);
	const isDevModeActive = useAppSelector((state) => state.system.devMode);

	return (
		<MenuContent
			parts={[
				menuItem({
					label: t("Go To Center"),
					effect: () => {
						dispatch(
							moveSheetTo({ index: currentTabIndex, position: { x: 0, y: 0 } }),
						);
						dispatch(closeMenu());
					},
					disabled: logicsStatus.code !== "succeeded",
				}),
				isDevModeActive
					? menuItem({
							label: t("Disable Dev Mode"),
							effect: () => {
								dispatch(disableDevMode());
								dispatch(closeMenu());
							},
							disabled:
								logicsStatus.code === "succeeded" &&
								!logicsStatus.logics.commit.name.startsWith("JSON_"),
						})
					: menuItem({
							label: t("Enable Dev Mode"),
							effect: () => {
								dispatch(enableDevMode());
								dispatch(closeMenu());
							},
						}),
				menuItem({
					label: t("Shortcuts"),
					effect: () => {
						dispatch(closeMenu());
						const windowSize = { x: 500, y: 300 };

						dispatch(
							createWindow({
								title: "Shortcuts",
								size: windowSize,
								position: {
									x: (window.innerWidth - windowSize.x) / 2,
									y: (window.innerHeight - windowSize.y) / 2,
								},
								typeAndProps: {
									type: "shortcut",
									props: {},
								},
							}),
						);
					},
				}),
			]}
		/>
	);
}
